<template>
  <div v-if="isAdmin"
    class="is-border-left is-border-right">
    <div v-if="advs && advs.length">
      <table
        class="table is-hoverable is-striped-v is-fullwidth is-first-fixed-xsmall is-marginless-bottom is-border-bottom is-border-top">
        <thead>
        <tr class="is-size-6">
          <th>Statut</th>
          <th>Ref. ADV</th>
          <th>Lot</th>
          <th>Société</th>
          <th>Vendeur</th>
          <th>Contact</th>
          <th>Date de réservation</th>
        </tr>
        </thead>
        <tbody>
        <tr class="is-border-top is-size-6" v-for="adv in advs" :key="adv.pk">
          <td class="has-text-centered">
              <span class="dot tooltip" :class="adv.status|dotClass"
                    :data-tooltip="adv.status|statusLabel"></span>
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'AdvInfos', params: {id: adv.pk}}" class="fullLink">
              <span class="">{{adv.ref}}</span>
            </router-link>
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'LotVue', params: {id: adv.lot.pk || adv.lot}}" class="fullLink">
              {{adv.lot_ref}}
            </router-link>
          </td>
          <td>
            <router-link v-if="adv.company" :to="{name: 'CompanyVue', params: {id: adv.company}}">
              {{adv.company_name}}
            </router-link>
            <span v-else>--</span>
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'UserVue', params: {id: adv.seller}}">
              {{adv.seller_name}}
            </router-link>
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'ContactVue', params: {id: adv.buyer}}">
              {{adv.buyer_name}}
            </router-link>
          </td>
          <td>
            <span v-if="adv.signature_date">{{adv.signature_date | dtFormat('DD/MM/YYYY')}}</span>
            <span v-else>NC</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="column">
      <em><b>Aucune vente.</b></em>
    </div>
  </div>
</template>

<script>
  import { OptionStatus, DefaultValues } from '../../../mixins'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ProgramAdvList',
    mixins: [OptionStatus, DefaultValues],
    computed: {
      ...mapGetters(['isAdmin'])
    },
    props: {
      advs: {
        type: Array,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/Tabs/ProgramAdvList.vue